export const getTrustPilotWidgetData = async (
  id: string,
  buid: string,
  locale: string
) => {
  const dataUrl = `https://widget.trustpilot.com/trustbox-data/${id}?businessUnitId=${buid}&locale=${locale}&reviewStars=5&reviewsPerPage=1`;

  try {
    const response = await fetch(dataUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      next: {
        tags: [`trustpilot-widget-${buid}-${locale}`],
      },
    } as RequestInit & { next: { tags: string[] } });

    if (!response.ok) throw new Error('Failed to fetch TrustPilot data');
    return response.json();
  } catch (error) {
    console.error(error);
  }
};
